import AdminSidebar from "components/layout/AdminSidebar";
import Container from "components/layout/Container";
import Main from "components/layout/Main";
import VButton from "components/ui/VButton";
import { COIN_CONFIG } from "constants/coin.constant";
import useAsync from "hooks/useAsync";
import { useEffect, useMemo, useState } from "react";
import { showDanger, showSuccess } from "utilities/misc";
import { post } from "utilities/network";

const coinKeys = Object.keys(COIN_CONFIG) as (keyof typeof COIN_CONFIG)[];

const RestoreMissedTransaction: React.FC = () => {
  const [coin, setCrypto] = useState<string>("");
  const [network, setNetwork] = useState<string>("");
  const [hash, setHash] = useState<string>("");

  const availableNetworks = useMemo(() => {
    if (!coin) return [];
    const config = COIN_CONFIG[coin as keyof typeof COIN_CONFIG];
    if (!config) return [];
    return Object.entries(config.networks).map(([key, net]) => ({
      key,
      name: net.name,
    }));
  }, [coin]);

  useEffect(() => {
    if (availableNetworks.length === 1) {
      setNetwork(availableNetworks[0].key);
    } else {
      setNetwork("");
    }
  }, [availableNetworks]);

  const {
    execute: restoreMissedHash,
    status,
    value,
  } = useAsync(
    () =>
      post(`transactions/queryMissedPublic`, {
        crypto: coin,
        network,
        hash,
      }),
    false,
  );

  const handleSubmit = () => {
    if (!coin) return showDanger("Select a crypto");
    if (!network) return showDanger("Select a network");
    if (!hash || hash.length < 3) return showDanger("Enter valid hash");
    restoreMissedHash();
  };

  useEffect(() => {
    if (value?.data?.success) {
      showSuccess(value?.data?.message || "Transaction restored successfully");
      setCrypto("");
      setNetwork("");
      setHash("");
    }
  }, [value]);

  return (
    <Container>
      <AdminSidebar />
      <Main className="mx-5 mt-5 text-left">
        <h2 className="text-xl">Restore Missed Transaction</h2>
        <div className="flex gap-8 mt-14">
          <div className="w-6/12">
            <div className="relative mb-5 md:w-10/12">
              <label>Crypto</label>
              <select
                className="w-full py-3 pl-8 mt-1 border-gray-400 rounded"
                value={coin}
                onChange={(e) => setCrypto(e.target.value)}
              >
                <option value="">Select Crypto</option>
                {coinKeys.map((key) => (
                  <option key={key} value={key}>
                    {key.toUpperCase()}
                  </option>
                ))}
              </select>
            </div>
            <div className="relative mb-5 md:w-10/12">
              <label>Network</label>
              <select
                className="w-full py-3 pl-8 mt-1 border-gray-400 rounded"
                value={network}
                onChange={(e) => setNetwork(e.target.value)}
                disabled={!coin}
              >
                <option value="">Select Network</option>
                {availableNetworks.map((net) => (
                  <option key={net.key} value={net.key}>
                    {net.name}
                  </option>
                ))}
              </select>
            </div>
            <div className="relative mb-5 md:w-10/12">
              <label>Enter Missed Hash</label>
              <input
                type="text"
                value={hash}
                onChange={(e) => setHash(e.target.value)}
                className="w-full py-3 pl-8 mt-1 border-gray-400 rounded"
              />
            </div>

            <div className="text-center">
              <VButton
                status={status}
                onClick={handleSubmit}
                className="w-4/12 px-20 py-3 mt-5 font-light text-white bg-black rounded-lg"
              >
                Restore Hash
              </VButton>
            </div>
          </div>
        </div>
      </Main>
    </Container>
  );
};
export default RestoreMissedTransaction;
